import React from 'react';
import AppNavbar from '../components/navbar';
import AppFooter from '../components/footer';
import {supabase} from '../database/database';
import { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import BlogPagination from '../components/BlogPagination';
import LoadingState from '../components/LoadingState';
import PostContent from '../components/PostContent';
import PostTags from '../components/PostTags';
import AuthorLink from '../components/AuthorLink';
import ViewCount from '../components/ViewCount';
import ResponsiveImage from '../components/ResponsiveImage';
import { getVoteCounts } from '../utils/votes';

const PAGE_SIZE = 5;

async function getBlogs(page) {
    const start = (page - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE - 1;
    const { data, count, error } = await supabase
    .from('blogs')
    .select('*', { count: 'exact' })
    .order('rating', { ascending: false })
    .order('created_at', { ascending: false })
    .range(start, end);
    return { data: data ?? [], count: count ?? 0, error };
}

function Home() {
    const [blogs, setBlogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        let isCurrent = true;
        setIsLoading(true);
        getBlogs(currentPage).then(({ data, count, error }) => {
            if (!isCurrent) return;
            if (error) console.error(error);
            setBlogs(data);
            setTotalCount(count);
            setIsLoading(false);
        });
        return () => { isCurrent = false; };
    }, [currentPage]);
    const [totalCount, setTotalCount] = useState(0);
    if(isLoading){
        return (
            <>
            <AppNavbar/>
            <LoadingState label="Loading the community feed" />
            <AppFooter/>
            </>
        )
    }
    if(blogs.length === 0){
        return (
            <>
            <AppNavbar/>
            <main className="page-shell feed-page">
                <div className="feed-heading">
                    <div><span className="eyebrow">The community feed</span><h1>Ideas, in good company.</h1><p>Fresh perspectives from people who love sharing what they know.</p></div>
                    <Button onClick={() => window.location.href = '/create'}>Write a post</Button>
                </div>
                <div className="editor-panel"><h2>No posts just yet</h2><p>Be the first to share an idea with the community.</p><Button onClick={() => window.location.href = '/create'}>Create the first post</Button></div>
            </main>
            <AppFooter/>
            </>
        )
    }
        return (
            <>
            <AppNavbar/>
            <main className="page-shell feed-page">
                <div className="feed-heading">
                    <div><span className="eyebrow">The community feed</span><h1>Ideas, in good company.</h1><p>Fresh perspectives from people who love sharing what they know.</p></div>
                    <Button onClick={() => window.location.href = '/create'}>Write a post</Button>
                </div>
                <div className="feed-list">
                {blogs.map((blog, index) => {
                    return (
                        <div key={blog.id}>
                        <Card className="post-card">
                        <Card.Header><span className="post-meta"><AuthorLink userId={blog.user} name={blog.Author} /><span>Community writer</span></span><span className="eyebrow">Post</span></Card.Header>
                            
                            <Card.Body>
                                <Card.Title as="h2">{blog.title}</Card.Title>
                                <PostTags tags={blog.tags} />
                                <PostContent className="post-preview" html={blog.blog} />
                                {blog.imageURL && <ResponsiveImage className="card-img post-cover" src={blog.imageURL} variants={blog.image_variants} alt={blog.title} priority={index === 0} />}

                                <div className="post-actions">
                                    <Button href={`/viewBlog?id=${blog.id}`} variant='primary'>Read post</Button>
                                    <span className="vote-count">▲ {getVoteCounts(blog).upvotes} upvotes</span>
                                    <span className="vote-count">▼ {getVoteCounts(blog).downvotes} downvotes</span>
                                    <ViewCount count={blog.view_count} />
                                </div>
                            </Card.Body>
                            
                            
                            <Card.Footer><small>Published {(blog.created_at).split('T')[0]}</small><span className="post-meta">Score <strong>{blog.rating || 0}</strong></span></Card.Footer>
                        </Card>
                       
                       </div>
                   
                    )
                })}
                </div>
                <BlogPagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(totalCount / PAGE_SIZE)}
                    onPageChange={setCurrentPage}
                />
            </main>
            <AppFooter/>
            </>
        )
    

}
  export default Home;
  